import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { MessageSquare, FileText, Clock, CheckCircle, Monitor, HeadphonesIcon } from "lucide-react";

export function FlowSection() {
  const steps = [
    {
      step: "1",
      title: "ご相談・ヒアリング",
      description: "研修目的・内容の確認、助成金活用の可否判断を行います。",
      icon: MessageSquare
    },
    {
      step: "2",
      title: "契約締結とご入金",
      description: "研修内容・条件にご同意いただいた上で、業務委託契約を締結し、指定口座へのご入金をお願いいたします。",
      icon: FileText
    },
    {
      step: "3",
      title: "お客様による書類準備期間",
      description: "助成金申請に必要な書類をご準備いただきます：\n・雇用契約書の写し（受講予定者分）\n・研修実施場所の見取り図（社内実施の場合）\n・記入済みのヒアリングシート（弊社指定フォーマット）",
      icon: Clock
    },
    {
      step: "4",
      title: "助成金申請サポート",
      description: "専門家と連携し、必要書類の作成・提出をサポートいたします。",
      icon: CheckCircle
    },
    {
      step: "5",
      title: "研修の実施（オンラインまたは訪問）",
      description: "座学＋ワークショップ形式で、全3回・10時間の実践的な研修を提供します。",
      icon: Monitor
    },
    {
      step: "6",
      title: "終了後のフォローと活用アドバイス",
      description: "定着支援のアドバイスや、社内での活用方法の振り返りを実施します。",
      icon: HeadphonesIcon
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            研修実施までの流れ
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            お問い合わせから研修完了まで、安心のサポート体制
          </p>
        </div>
        
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-black text-white rounded-full flex items-center justify-center text-lg sm:text-xl mr-4 sm:mr-6">
                  {step.step}
                </div>
                <Card className="flex-1 border-gray-200 shadow-sm">
                  <CardHeader>
                    <CardTitle className="flex items-center text-lg sm:text-xl text-gray-900">
                      <step.icon className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-black" />
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm sm:text-base text-gray-700 whitespace-pre-line leading-relaxed">{step.description}</p>
                  </CardContent>
                </Card>
              </div>
              {index < steps.length - 1 && (
                <div className="absolute left-8 top-20 w-0.5 h-8 bg-gray-300"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
